import React from 'react';

interface LinkButtonProps {
  onClick: () => void;
  children: React.ReactNode;
}

/**
 * Text-like action button used for inline navigation links.
 * @param props - Click handler and rendered label content.
 * @returns Clickable inline action element.
 */
export const LinkButton = ({ onClick, children }: LinkButtonProps) => {
  
  return <div style={{
    color: '#AC2A6E',
    fontSize: 14,
    fontWeight:'bold',
    cursor: 'pointer',
  }} onClick={() => {
    onClick()
  }}>{children}</div>
}